const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin/channels/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { adminPageTitle } from "@/routes/_app/admin/admin-page-title";
import { parseAdminChannelsSearch } from "./-parse-admin-channels-search";
export const Route = createFileRoute("/_app/admin/channels/")({
  head: () => ({
    meta: [{
      title: adminPageTitle("Channels")
    }]
  }),
  validateSearch: parseAdminChannelsSearch,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});